import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { colonosRoutes } from '@/modules/colonos/routes'

Vue.use(VueRouter)

const routes = [
  // Rutas principales del módulo colonos
  colonosRoutes,

  /* ===========================
  * ADMINISTRACIÓN
  * ========================= */
  {
    path: '/loginadmin',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.rutaProtegida) {
    if (store.getters.usuarioAutenticado) {
      next()
    } else {
      next(`/nosesion?redirect=${to.fullPath}`)
    }
  } else {
    next()
  }
})

export default router
